<template>
  <section class="main-box">
    <el-row>
      <el-col :span="24" class="q-title">
        <div class="q-title"><i></i>{{formObj.rectifyName}}-整改单</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="q-tab-title">
        <div class="q-tab-title"><i></i>隐患表述</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="q-w">
          {{formObj.rectifyDesc}}
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="q-tab-title">
        <div class="q-tab-title"><i></i>整改措施</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="q-w">
          {{formObj.rectifyMeasure}}
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" >
        <img :src="item.url" v-for="item in picList" class="imglist"/>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="q-mes">
        <el-row>
          <el-col :span="24" class="q-mes-f">项目名称：{{formObj.rectifyName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">分部工程/分项：{{formObj.sortProject.proName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">问题类型：{{formObj.questionType.quName}}</el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="q-mes">
        <el-row>
          <el-col :span="24" class="q-mes-f">检查人员：{{formObj.checkName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f"><div class="q-w">责任施工人员：{{formObj.conName}}</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f"><div class="q-w">责任人：{{formObj.rectifyDutyUserN}}</div></el-col>
        </el-row>
      </el-col>
    </el-row>

  </section>
</template>

<script>

  import {rectifyDetail,updateByuseranddis} from '../../api/api'
  export default {
    name: 'discloseview',
    data(){
      return{
        realVisible:false,
        mForm:{},
        mRules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入身份证号码', trigger: 'blur'}
          ]
        },
        formObj:{ sortProject:{proName:''},questionType:{quName:''}},
        submitObj:{},
        detailId:0,
        picList:[]
      }
    },
    methods: {
      getURLParam: function (paraName) {
        var url = document.location.toString()
        var arrObj = url.split('?')
        if (arrObj.length > 1) {
          var arrPara = arrObj[1].split('&')
          var arr
          for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=')
            if (arr != null && arr[0] == paraName) {
              return arr[1]
            }
          }
          return ''
        } else {
          return ''
        }
      },
      openRealView:function(){
        this.mForm = {};
        this.realVisible=true;
      },
      doReal:function(){
        this.$refs.mForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitObj.userId = null;
              this.submitObj.userCode = this.mForm.code
              this.submitObj.reId = this.detailId;
              this.submitObj.parent = 0;
              this.submitObj.replyPhoto = "";
              updateByuseranddis(this.submitObj,this.GLOBAL.header).then(result=>{
                  if(result.success)
                  {
                    this.$message({
                      message: "成功",
                      type: 'success'
                    });

                  }else {
                    this.$message({
                      message: "身份证有误",
                      type: 'error'
                    });
                  }
                this.realVisible=false;
              });

            });
          }
        });
      }
    },
    mounted () {
      this.detailId = this.getURLParam('id');
      let param = {
        id: this.detailId
      };

      rectifyDetail(param,this.GLOBAL.header).then(result=>{
        if(result.success){
          this.formObj = result.data;
          if(this.formObj==null)
          {
            this.$router.push('/');
          }
          if(result.data.rectifyPhoto !=null){
            this.filePathList = result.data.rectifyPhoto.split(',');
            for(var i = 0 ; i < this.filePathList.length; i++) {
              if(this.filePathList[i]!=''){
                this.picList.push({url: this.GLOBAL.basePhotoPath + "" + this.filePathList[i]})
              }
            }
          }
        }
      });
    }
  }
</script>

<style scoped>
  .imglist{ width: 100px; height: 100px; margin-right: 10px;margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/qrcodeview/Rectifyview.vue